<template>
    <div class="home-component">
        <div class="enter-membership-form">
            <div class="upcoming-events-title">
                今後のイベント予定
            </div>

            <div class="upcoming-events-gallery-1">

                <button class="upcoming-event-feb-2" @click="clickedMarch24()">
                    <button class="event-photo">
                        <img class="next-event-photo" src="./../assets/final-march-24-banner.png" alt="Next event" height="150">
                    </button>

                    <div class="text-container">
                        <div class="event-date">
                        3月24日 日曜日
                    </div>

                    <div class="event-title">
                        Sauna+Ice Bath: Social
                    </div>

                    <div class="event-subtitle">
                        サウナ×アイスバス×DJ
                    </div>
                    </div>
                </button>

            </div>

            <hr class="section-hr">

            <div class="upcoming-events-title-2">
                過去のイベント
            </div>

            <div class="upcoming-events-gallery-2">

                <button class="upcoming-event-feb-2-2" @click="clickedFebruary4()">
                    <button class="event-photo">
                        <img class="next-event-photo" src="./../assets/february-4-poster.png" alt="Next event" height="150">
                    </button>

                    <div class="text-container">
                        <div class="event-date">
                        2月4日 日曜日
                    </div>

                    <div class="event-title">
                        ELEVATE: Social
                    </div>

                    <div class="event-subtitle">
                        サウナ×アイスバス×DJ
                    </div>
                    </div>
                </button>

                <button class="upcoming-event-feb-2-2" @click="clickedJanuary13()">
                    <button class="event-photo">
                        <img class="next-event-photo" src="./../assets/january-13-poster.png" alt="Next event" height="150">
                    </button>

                    <div class="text-container">
                        <div class="event-date">
                        1月13日 土曜日
                    </div>

                    <div class="event-title">
                        ローンチパーティー
                    </div>

                    <div class="event-subtitle">
                        サウナ×アイスバス×DJ
                    </div>
                    </div>
                </button>

            </div>

        </div>
        
    </div>
</template>

<style scoped>

.text-container {
    text-align: left;
}
.hr {
    display: none;
}
    .upcoming-events-gallery-1 {
        display: grid;
        grid-area: 1 / 1;
        grid-template-columns: 320px 1fr 320px 1fr;
        grid-gap: 40px;
    }

    .upcoming-events-gallery-2 {
        display: grid;
        grid-area: 1 / 1;
        grid-template-columns: 320px 1fr 320px 1fr;
        grid-gap: 40px;
    }

    .upcoming-event-feb-2 {
        padding-left: 20px;
        display: flex;
        flex-direction: column;
        cursor: pointer;
        background: none; 
        border: none;
    }

    .upcoming-event-feb-2-2 {
        padding-left: 20px;
        display: flex;
        flex-direction: column;
        cursor: pointer;
        background: none; 
        border: none;
        -webkit-filter: grayscale(100%); /* Safari 6.0 - 9.0 */
        filter: grayscale(100%);
    }


    .upcoming-events-title {
        font-family:  SFPRoSemiBold;
        font-size: 20pt;
        padding-left: 20px;
        padding-top: 20px;
        padding-bottom: 20px;
        padding-right: 20px;
    }

    .upcoming-events-title-2 {
        font-family:  SFPRoSemiBold;
        font-size: 20pt;
        padding-left: 20px;
        padding-top: 20px;
        padding-bottom: 45px;
        padding-right: 20px;
    }
    
    
    .next-event-photo {
        width: 300px;
        height: 300px;
        border-radius: 12pt;
        object-fit: cover;
        cursor: pointer;
    }

    .event-subtitle {
        padding-bottom: 10px;
    }

    .event-photo {
        overflow: hidden;  
        border-radius: 12pt;
        background-color: red;  
        background: none; 
        border: none;
    }

    .event-date {
        color: white;
        font-size: 14pt;
        font-family:  SFPRoLight;
        padding-bottom: 10px;
        padding-top: 4px;
    }

.event-title {
        color: white;
        font-size: 16pt;
        font-family:  SFPRoSemiBold;
    }

    .next-event-photo:hover {
    transform: scale(1.05); /* (150% zoom - Note: if the zoom is too large, it will go outside of the viewport) */
    }
    
    .next-event-photo {
        
    display: block;
    transition: transform .4s;   /* smoother zoom */
}

    .event-subtitle {
        color: white;
        font-size: 16pt;
        font-family:  SFPRoRegular;
    }

    .nav-buttons {
        padding-right: 16px;
        display: flex;
        gap: 10px;
    }

    .enter-membership-form {
        background-color: rgb(35,32,38);
        /* display: flex; */
        width:auto;
        margin-left:15px;
        margin-right:15px;
        margin-top: 50px;
        padding-bottom: 20px;
        background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='10' ry='10' stroke='%23333' stroke-width='4' stroke-dasharray='6%2c 14' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e");
        border-radius: 10px;
        margin-bottom: 40px;
    }

    .upcoming-events-nav-bar {
        color: white;
        font-family:  SFPRoRegular;
        font-size: 18pt;
    }

    .your-account-nav-bar {
        color: white;
        font-family:  SFPRoRegular;
        font-size: 18pt;
        margin-left: 16px
    }

    .upcoming-events-title {
        color: white;
    }

    .upcoming-events-title-2 {
        color: white;
    }

    .home-component {
        max-width: 960px; 
        gap: 0px;
        margin: 0 auto; 
        float: none !important; 
        min-height: calc(100vh - 110px);
        /* display: flex; */
        align-items: center;
        justify-content: top;
        flex-direction: column;
        background: rgb(34, 32, 37);
        /* padding-top: 20pt; */
        margin-top: -100px;
        /* background-image: url("./../../assets/elevate-tiling.png"); */
    }

    .waiver-link {
        color: white;
        font-family:  SFPRoRegular;
        font-size: 14pt;
    }

    .button-container {
        display: flex;
         justify-content: center;
         margin-top: 35pt;
    }

    .session-detail-component-header-logo {
        height: 100pt;
        align-items: left;
        object-fit: contain;
        display: flex;
        justify-content: left;
        padding-left: 20pt;
    }

    .app-header {
        height: 100pt;
        width: 100%;
        justify-content: space-between;
        align-items: left;
        display: flex;
        
    }

    .app-header-nav-bar {
        height: 10pt;
        width: auto;
        justify-content: space-between;
        align-items: left;
        padding-right: 10pt;
        display: flex;
    }
    
    .membership-number-text-field {
        height: 35px;
        font-family:  SFPRoRegular;
        font-size: 14pt;
        box-sizing: border-box;
    }

    .home-component-elevate-title {
        font-family: SFPRoBold;
        font-size: 16pt;
    }

    .membership-number-text-field-label {
        font-family: SFPRoBold;
        color: white;
        padding-top: 15pt;
    }

    .membership-number-text-field {
        width: 100%;
        margin-bottom: 2pt;
        margin-top: 6pt;
    }

    .password-number-text-field {
        width: 100%;
        margin-bottom: 2pt;
        margin-top: 6pt;
    }

    .membership-number-text-field-sub-label {
        font-family: SFPRoRegular;
        color: white;
        font-size: 12pt;
        margin-bottom: 20pt;
        margin-top: 4pt;
    }

    .membership-number-submit {
        height: 40px;
        background-color: rgb(225, 228, 99);
        cursor: pointer;
        border: none;
        border-radius: 8px;
        color: black;
        font-family: SFPRoBold;
        font-size: 16px;
        transition: 300ms;
        width: 150pt;
        align-items: center;
        justify-content: center;
    }

    @media only screen and (max-width: 1000px) {
     .container {
        display: flex;
        flex-direction: column;
   }

   .upcoming-events-title {
    padding-left: 27px;
   }

   .upcoming-events-title-2 {
    padding-left: 27px;
   }
}

@media only screen and (max-width: 1000px) {
   .upcoming-events-gallery-1 {
        grid-template-columns: 1fr;
        padding-bottom: 35px;
   }

   .upcoming-events-gallery-2 {
        grid-template-columns: 1fr;
   }

   .hr {
    display: flex;
    width: 100%;
}
}

@media only screen and (max-width: 1000px) {

    .section-hr {
        display: none;
    }

    .upcoming-event-feb-2 {
        padding-left: 20px;
        display: flex;
        flex-direction: row;
        margin-bottom: -25px;
    }

    .upcoming-event-feb-2-2 {
        padding-left: 20px;
        display: flex;
        flex-direction: row;
        margin-top: -23px;
    }

    .upcoming-events-gallery-1 {
        margin-bottom: 5px;
    }

    .upcoming-events-gallery-2 {
        margin-bottom: 5px;
    }
    
    .next-event-photo {
        max-width: 100px;
        max-height: 100px;
        margin-right: 15px;
    }
}



.sign-up-for-membership-page {
    font-family: SFPRoRegular;
    color: white;
    font-size: 14pt;
    margin-top: 5pt;
}

.member-log-in-title {
    font-family: SFPRoBold;
    color: white;
    font-size: 18pt;
    margin-top: 50pt;
    text-align: left;
    display: flex;
}

</style>

<script setup>
import { useRouter } from "vue-router";
const router = useRouter();

function clickedFebruary4() { 
    router.push('/session-detail-february-4');
 } 

 function clickedMarch24() { 
    router.push('/session-detail-march-24');
 } 

 function clickedJanuary13() { 
    router.push('/session-detail-january-13');
 } 
</script>

<script>


export default {
    mounted () {
        window.scrollTo(0, 0);
    }
}
</script>
